import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Check, Globe2 } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../hooks/useLanguage';
export function SolutionSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 px-4 bg-[#111118] border-y border-white/5" data-id="element-138">
      <div className="max-w-6xl mx-auto" data-id="element-139">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-141">
            <div className="flex items-center gap-2 text-[#D4A843] font-bold mb-4" data-id="element-142">
              <Sparkles className="w-5 h-5" data-id="element-143" />
              {t('solution_label')}
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-144">
              {t('solution_h2')} <br data-id="element-145" />
              <span className="text-[#D4A843] text-glow" data-id="element-146">"CV Go"</span>
            </h2>

            <p className="text-xl text-gray-300 mb-4" data-id="element-147">
              {t('solution_subtitle_before')}{' '}
              <strong className="text-white" data-id="element-148">
                {t('solution_subtitle_highlight')}
              </strong>
              {t('solution_subtitle_after')}
            </p>

            <p className="text-sm text-[#D4A843] font-medium mb-8 flex items-center gap-2" data-id="element-149">
              <Globe2 className="w-4 h-4" data-id="element-150" />
              {t('solution_bilingual')}
            </p>

            <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-151">
              {t('solution_description')}
            </p>

            <div className="space-y-4 mb-8" data-id="element-152">
              {[t('solution_feature1'), t('solution_feature2'), t('solution_feature3')].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-153">
                  <div className="w-6 h-6 rounded-full bg-[#22C55E]/20 flex items-center justify-center text-[#22C55E]" data-id="element-154">
                    <Check className="w-4 h-4" data-id="element-155" />
                  </div>
                  <span className="text-gray-200" data-id="element-156">{item}</span>
                </div>)}
            </div>

            <Button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-157">
              {t('solution_cta')}
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-158">
            {/* Abstract visual representation of the bundle/app */}
            <div className="relative aspect-square md:aspect-[4/3] rounded-2xl overflow-hidden border border-white/10 bg-[#0A0A0F] shadow-2xl" data-id="element-159">
              <div className="absolute inset-0 bg-gradient-to-br from-[#D4A843]/20 to-transparent opacity-50" data-id="element-160" />

              {/* UI Mockup elements */}
              <div className="absolute inset-8 bg-[#1A1A24] rounded-xl border border-white/5 p-6 flex flex-col shadow-inner" data-id="element-161">
                <div className="flex items-center justify-between mb-6 border-b border-white/5 pb-4" data-id="element-162">
                  <div className="w-32 h-4 bg-white/10 rounded" data-id="element-163" />
                  <div className="w-8 h-8 bg-[#D4A843] rounded-full flex items-center justify-center" data-id="element-164">
                    <Check className="w-5 h-5 text-black" data-id="element-165" />
                  </div>
                </div>
                <div className="space-y-4" data-id="element-166">
                  <div className="h-4 bg-white/5 rounded w-3/4" data-id="element-167" />
                  <div className="h-4 bg-white/5 rounded w-1/2" data-id="element-168" />
                  <div className="h-24 bg-white/5 rounded w-full mt-4" data-id="element-169" />
                </div>

                <div className="mt-auto pt-6 border-t border-white/5" data-id="element-170">
                  <div className="flex items-center justify-between text-sm" data-id="element-171">
                    <span className="text-gray-500" data-id="element-172">
                      {t('solution_ats_label')}
                    </span>
                    <span className="text-[#22C55E] font-bold" data-id="element-173">
                      {t('solution_ats_value')}
                    </span>
                  </div>
                  <div className="w-full h-2 bg-gray-800 rounded-full mt-2 overflow-hidden" data-id="element-174">
                    <div className="h-full bg-[#22C55E] w-[98%]" data-id="element-175" />
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}